import { render } from "./ProductInfoView.vue?vue&type=template&id=2e97be8a"
import script from "./ProductInfoView.vue?vue&type=script&lang=js"
export * from "./ProductInfoView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__